<template>
    <div class="breadcrumbs">
        <span>
            <router-link :to="{ path: '/' }" class="fsColor">{{ $t('breadcrumb.breadText1') }}</router-link>
            <span class="breadcrumbs-separator">&gt;</span>
        </span>
        <span v-for="(crumb, index) in list" :key="index">
            <router-link :to="crumb.path" class="fsColor" :class='{ fsActive: index == list.length - 1}'>{{ $t(crumb.name) }}</router-link>
            <span v-if="index !== list.length - 1" class="breadcrumbs-separator">&gt;</span>
        </span>
    </div>
</template>
<script>
export default {
    props: ["list"]
}
</script>
<style lang="scss">
.breadcrumbs {
    margin-bottom: 10px;
    background: #F3F2F2;
    padding-left: 20px;

    font-size: 12px;


    line-height: 22px;
}

.fsColor {

    color: #979797;
    font-weight: bold;
}

.breadcrumbs span {
    white-space: nowrap;
}

.breadcrumbs-separator {
    margin-left: 5px;
    margin-right: 5px;

    color: #979797;
    font-weight: bold;
}
.fsActive{
    color: #D31319;
}
</style>
 


// WEBPACK FOOTER //
// src/components/breadCrumb.vue